export enum ControlType {
    // Typography
    Paragraph = "Paragraph", // done
    Text = "Normal Text", // done
    Label = "Label", // done
    Badge = "Badge", // done
    Heading1 = "Heading 1", // done
    Heading2 = "Heading 2", // done
    Heading3 = "Heading 3", // done
    Heading4 = "Heading 4", // done
    Heading5 = "Heading 5", // done
    Heading6 = "Heading 6", // done
    NameLookup = "NameLookup", // done
    OwnerNameLookup = "OwnerNameLookup", // done
    EnumLabel = "EnumLabel", // done

    // Input Components
    Checkbox = "Checkbox", // done
    FileInput = "FileInput", // done
    Date = "Date", // done
    DateTime = "DateTime", // done
    Radio = "Radio", // done
    TextBox = "Text Box", // done
    NumberInput = "NumberInput", // done
    TextArea = "Text Area", // done
    HiddenInput = "HiddenInput", // done
    Dropdown = "Dropdown", // dine
    Time = "Time", // done
    Password = "Password", // done
    Lookup = "Lookup", // done

    // Payment Gateway
    PayUButton = "PayUPaymentButton", // done
    AMBankButton = "AMBankButton", // done
    PaytmButton = "PaytmButton", // done
    RazorPayButton = "RazorPayPaymentButton", // done
    NTTPayButton = "NTTPayButton", // done
    FlywireButton = "FlywireButton", // done
    HdfcButton = "HdfcButton", // done
    PaymentButtonComponent = "PaymentButtonComponent", // done

    // Buttons
    Button = "Button", // done
    SubmitButton = "SubmitButton", // done
    ActionButton = "ActionButton", // done
    ResetButton = "Reset Data", // done

    // Links
    Hyperlink = "Hyperlink",
    CardNavigation = "Page Link",
    ListNavigation = "List Navigation",
    DownloadableDocument = "Downloadable Document",
    TOULink = "TOU Link",
    UMSLink ="UMS Link",

    // Media
    Image = "Image",
    Video = "Video",
    Media = "Media",
    AvatarText = "Avatar Text",
    MaterialIcon = "Material Icon",
    GoogleMaps = "Google Maps",
    Base64Image = "Base64Image",

    // Charts
    PieChart = "Pie Chart",
    StackedBars = "Stacked Bars",

    // Page Components
    ListPart = "List Part", // done
    CardPart = "Card Part", // done
    DropdownPage = "Dropdown Page", // done
    Offcanvas = "Offcanvas",

    // Cards & Panels
    Accordion = "Accordion",
    AccordionItem = "Accordion-Item",
    Section = "Section",
    Panel = "Panel",

    // Tables & Lists
    List = "List",
    Grid = "Grid",
    Repeater = "Repeater",
    RepeaterColumn = "Repeater Column",

    // Application-Focused Components
    Services = "Services",
    ServiceRequest = "Service Request",
    GatePassServiceRequest = "Gate Pass Service Request",
    Chat = "Chat",
    EntityDocumentChecklist = "Document Checklist",
    DocumentChecklist = "DocumentChecklist",
    AcademicRegistrationComponent = "Academic Registration",
    ABCIDFormComponent = "ABC-ID Form Component",
    BoardingPassComponent = "Boarding-pass Component",
    ExtendGatePassComponent = "Extend Gate Pass Component",
    IncidentReportingComponent = "IncidentReporting",
    RemedialSuppComponent = "Remedial Supplementary Registration",
    SupplimentaryComponent = "Supplementary Registration",

    // Documents
    SharePointDocuments = "SharePoint Documents",

    // Data & Filters
    DataLink = "Data Link",
    LookupFieldFilter = "LookupFieldFilter",

    // Input Forms
    FeedbackForm = "FeedbackForm",
    StudentKYCForm = "StudentKYCForm",

    // QR
    QRScanner = "QRScanner",
    QRCode = "QRCode",

    // Social Media
    YouTube = "YouTube",
    Twitter = "Twitter",
    Facebook = "Facebook",
    LInkedIn = "LInkedIn",

    // Miscellaneous
    Options = "Options",
    ProgressBar = "Progress Bar",
    Slider = "Slider",
    Custom = "Custom",
    Form = "Form",

    // Views
    Timeline = "Timeline",
    Calendar = "Calendar",
    Carousel = "Carousel",
    HTMLView = "HTMLViewer", // done
    Marquee = "Marquee", // done
    IFrame = "IFrame", // done

    // Face
    WebcamImage = "WebcamImage",
    DetectFace = "DetectFace",
    FeedbackFormComponent = "FeedbackFormComponent",
    ShuttleBooking = "ShuttleBooking",
    ShowShuttleBookings = "ShowShuttleBookings",
    ShuttlePaymentSuccessful = "ShuttlePaymentSuccessful",
    UnderTakingComponent = "UnderTakingComponent",
    TakeHomeExaminationComponent = "TakeHomeExaminationComponent",

    // Cookie
    CookieVerification = "CookieVerification",
    CookieRegistration = "CookieRegistration",
    OtpVerification = "OtpVerification",
    IPFilterComponent = "IP Filter",
} 